/** Shared Pay Connect gateway CDN logos (B2B portal + admin dashboard). */
export const PAY_CONNECT_CDN_LOGOS = {
  PY_WHISH:
    'https://cdn.prod.website-files.com/6762f4acf0dd8a6b998dfa16/676d32a11708f11b333c681b_Whish%20Logo.svg',
  PY_BLOM_UC: 'https://www.blombank.com/ContentFiles/1Logo1.png',
  PY_OMT: 'https://www.omt.com.lb/img/omt_pay.svg',
} as const

export type PayConnectCdnFactory = keyof typeof PAY_CONNECT_CDN_LOGOS
